import { createContext } from 'react';

import { UserContextValue } from './types/UserContextValue';

export const UserContext = createContext<UserContextValue>({
  user: null,
  isLoading: false,
  refetch: () => {},
});
